import React from "react"

import Link from "./link"

const Menu = ({ footer }) => {
  const onHover = () => {
    document.querySelector(".stays-link").classList.add("current")
    document.body.classList.add("submenu-open")
  }
  const openThirdMenu = () => {
    if (window.innerWidth > 768) {
      document.querySelector(".stays-link").classList.add("current")
      document.body.classList.add("third-open")
    }
  }
  const openSubmenu = e => {
    if (window.innerWidth > 768) return
    const submenu = e.target.closest(".primary--menu").querySelector(".eat--submenu")
    submenu?.classList.toggle("active")
  }

  const onLeave = () => {
    document.querySelector(".stays-link").classList.remove("current")
    document.body.classList.remove("submenu-open")
    document.body.classList.remove("third-open")
  }

  return (
    <div className='primary--menu flex flex-col'>
      <Link to='/' onMouseOver={onLeave} style={{ width: "120px" }} className='h3 link menu-link' activeClassName='active'>
        <span>Home</span>
        <span className='secondary'>Explore</span>
      </Link>
      {footer ? (
        <Link to='/accommodation' style={{ width: "320px" }} activeClassName='active' className='h3 m0 pointer link menu-link stays-link'>
          <span>Holiday Apartments</span>
          <span className='secondary'>Accommodation</span>
        </Link>
      ) : (
        <>
          <p to='/accommodation' onMouseOver={onHover} onFocus={onHover} role='presentation' style={{ width: "320px" }} activeClassName='active' className='m-hide h3 m0 pointer link menu-link stays-link'>
            <span>Holiday Apartments</span>
            <span className='secondary'>Accommodation</span>
          </p>
          <Link to='/accommodation' style={{ width: "320px" }} activeClassName='active' className='m-show h3 m0 pointer link menu-link stays-link'>
            <span>Holiday Apartments</span>
            <span className='secondary'>Accommodation</span>
          </Link>
        </>
      )}
      <Link onMouseOver={onLeave} to='/residences' activeClassName='active' className='h3 link menu-link'>
        <span>Residences</span>
        <span className='secondary'>Belong</span>
      </Link>
      <Link to='/retail' onMouseOver={onLeave} activeClassName='active' className='h3 link menu-link '>
        <span>Retail</span>
        <span className='secondary'>Shop</span>
      </Link>
      <Link to='/eat-drink' style={{ width: "180px" }} activeClassName='active' className='h3 pointer m0 link menu-link'>
        <span>Eat & Drink</span>
        <span className='secondary'>Quench</span>
      </Link>
      <div className='eat--submenu m-hide'>
        <Link to='/beach-hotel' activeClassName='active' className='h3 ml20 link menu-link'>
          Kirra Beach Hotel
        </Link>
        <br />
        <Link to='/beach-house' activeClassName='active' className='h3 ml20 link menu-link'>
          Kirra Beach House
        </Link>
      </div>
      <Link to='/guide' onMouseOver={onLeave} activeClassName='active' className='h3 link menu-link'>
        <span>The Local Guide</span>
        <span className='secondary'>Explore</span>
      </Link>
      {footer ? (
        <Link to='/page/groups' onMouseOver={onLeave} activeClassName='active' className='h3 link menu-link'>
          <span>Group Bookings</span>
          <span className='secondary'>Book</span>
        </Link>
      ) : (
        <Link to='/page/groups' onMouseOver={onLeave} activeClassName='active' className='h3 link m-show menu-link'>
          <span>Group Bookings</span>
          <span className='secondary'>Book</span>
        </Link>
      )}
      {footer && (
        <Link to='/page/community' onMouseOver={onLeave} activeClassName='active' className='h3 link menu-link'>
          <span>Community</span>
          <span className='secondary'>Community</span>
        </Link>
      )}
    </div>
  )
}

export default Menu

export const SecondaryMenu = () => {
  return (
    <div className='secondary--menu flex'>
      <div className='ml60 p15 ma secondary--links'>
        <Link to='/accommodation' activeClassName='active' className='h3 link menu-link'>
          Stay at Kirra Point
        </Link>
        <br />
        <Link to='/accommodation-apartments' activeClassName='active' className='h3 link menu-link'>
          Apartment Types
        </Link>
        <br />
        <Link to='/accommodation-facilities' activeClassName='active' className='h3 link menu-link'>
          Facilities
        </Link>
        <br />
        <Link to='/guide' activeClassName='active' className='h3 link menu-link'>
          The Local Guide
        </Link>
        <br />
        <Link to='/page/groups' activeClassName='active' className='h3 link menu-link'>
          Group Bookings
        </Link>

        <br />
        <Link to='/accommodation-faqs' activeClassName='active' className='h3 link menu-link'>
          FAQs
        </Link>
        <br />
      </div>
    </div>
  )
}

export const ThirdMenu = () => {
  return (
    <div className='third--menu flex'>
      <div className='ml60 p15 ma secondary--links'>
        <Link to='/beach-hotel' activeClassName='active' className='h3 link menu-link'>
          Kirra Beach Hotel
        </Link>
        <br />
        <Link to='/beach-house' activeClassName='active' className='h3 link menu-link'>
          Kirra Beach House
        </Link>
      </div>
    </div>
  )
}

export const SecondaryLinks = () => {
  return (
    <div className='secondary--links'>
      <Link to='/accommodation' activeClassName='active' className='h3 link menu-link'>
        Stay at Kirra Point
      </Link>
      <br />
      <Link to='/accommodation-apartments' activeClassName='active' className='h3 link menu-link'>
        Apartment Types
      </Link>
      <br />
      <Link to='/accommodation-facilities' activeClassName='active' className='h3 link menu-link'>
        Facilities
      </Link>
      <br />
      <Link to='/guide' activeClassName='active' className='h3 link menu-link'>
        The Local Guide
      </Link>
      <br />
      <Link to='/page/groups' activeClassName='active' className='h3 link menu-link'>
        Group Bookings
      </Link>
      <br />
      <Link to='/accommodation-faqs' activeClassName='active' className='h3 link menu-link'>
        FAQs
      </Link>
      <br />
    </div>
  )
}
